import * as React from 'react';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTh } from "@fortawesome/pro-solid-svg-icons/faTh";
export var HomeButton = function () {
  return /*#__PURE__*/React.createElement("p", {
    className: 'text-center push-topbig l-container h-center h-text-center c-home'
  }, /*#__PURE__*/React.createElement(Link, {
    to: '/'
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTh,
    className: 'fa-2x push-bottommedium'
  }), /*#__PURE__*/React.createElement("br", null), "Zur\u00FCck zur \u00DCbersicht"));
};